<template>
  <font-awesome-icon
    icon="file-download"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons'

library.add(faFileDownload)

export default {
  name: 'CoozzyFileDownloadIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
